// ISSUE-750. "512 KB", never a raw byte count, matching
// apps/admin/src/features/goalserve/goalserveFormat.ts's renderByteSize for
// an operator: same three bands, same rounding. A separate copy because
// apps/app and apps/admin are separate apps with no shared package for it.
export function formatFileSize(byteSize: number): string {
  if (!Number.isFinite(byteSize) || byteSize < 0) return "";
  if (byteSize < 1024) return `${String(byteSize)} B`;
  if (byteSize < 1024 * 1024)
    return `${String(Math.round(byteSize / 1024))} KB`;
  return `${(byteSize / (1024 * 1024)).toFixed(1)} MB`;
}
